import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Banknote, User } from "lucide-react";
import {
  DateField,
  NumberField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "../../common";

export const PayslipShow = () => (
  <Show>
    <Card className="form-container">
      <div className="form-header-premium">
        <Banknote className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Payslip Details</h2>
      </div>
      <SimpleShowLayout>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
          <Card>
            <CardHeader className="pb-3 border-b">
              <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500 flex items-center gap-2">
                <User className="w-3.5 h-3.5" /> Employee Information
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-4 space-y-3">
              <ReferenceField source="employee_id" reference="employees">
                <TextField source="name" className="employee-name text-lg block" />
              </ReferenceField>
              <div className="text-sm text-slate-500 flex items-center gap-2">
                <span className="font-semibold">Period:</span>
                <ReferenceField source="run_id" reference="hr_payroll_runs" link={false}>
                  <DateField source="period_month" />
                </ReferenceField>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardHeader className="pb-3 border-b">
              <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500">
                Attendance Summary
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-4 grid grid-cols-3 gap-2 text-center">
              <div>
                <div className="text-[10px] font-bold text-slate-400 uppercase mb-1">Working Days</div>
                <div className="text-xl font-medium"><TextField source="working_days" /></div>
              </div>
              <div>
                <div className="text-[10px] font-bold text-slate-400 uppercase mb-1">Present</div>
                <div className="text-xl font-medium text-emerald-600"><TextField source="present_days" /></div>
              </div>
              <div>
                <div className="text-[10px] font-bold text-slate-400 uppercase mb-1">Leave</div>
                <div className="text-xl font-medium text-amber-500"><TextField source="leave_days" /></div>
              </div>
            </CardContent>
          </Card>
          <Card className="md:col-span-2">
            <CardHeader className="pb-3 border-b">
              <CardTitle className="text-xs font-bold uppercase tracking-widest text-slate-500">
                Financial Breakdown
              </CardTitle>
            </CardHeader>
            <CardContent className="pt-4 grid grid-cols-3 gap-4">
              <div className="p-3 bg-slate-50 rounded-lg border">
                <div className="text-[10px] font-bold text-slate-400 uppercase mb-1">Gross Salary</div>
                <NumberField source="gross" options={{ style: "currency", currency: "INR" }} className="text-lg font-medium" />
              </div>
              <div className="p-3 bg-red-50 rounded-lg border border-red-100">
                <div className="text-[10px] font-bold text-red-400 uppercase mb-1">Deductions</div>
                <NumberField source="deductions" options={{ style: "currency", currency: "INR" }} className="text-lg font-medium text-red-600" />
              </div>
              <div className="p-3 bg-emerald-50 rounded-lg border border-emerald-100">
                <div className="text-[10px] font-bold text-emerald-500 uppercase mb-1">Net Pay</div>
                <NumberField source="net" options={{ style: "currency", currency: "INR" }} className="text-xl font-bold text-emerald-700" />
              </div>
            </CardContent>
          </Card>
        </div>
      </SimpleShowLayout>
    </Card>
  </Show>
);
